/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFaxReadStatusRequest
 */
export interface UpdateFaxReadStatusRequest {
    /**
     * 
     */
    is_read: boolean;
}

/**
 * Check if a given object implements the UpdateFaxReadStatusRequest interface.
 */
export function instanceOfUpdateFaxReadStatusRequest(value: object): value is UpdateFaxReadStatusRequest {
    if (!('is_read' in value) || value['is_read'] === undefined) return false;
    return true;
}

export function UpdateFaxReadStatusRequestFromJSON(json: any): UpdateFaxReadStatusRequest {
    return UpdateFaxReadStatusRequestFromJSONTyped(json, false);
}

export function UpdateFaxReadStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFaxReadStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'is_read': json['is_read'],
    };
}

export function UpdateFaxReadStatusRequestToJSON(json: any): UpdateFaxReadStatusRequest {
    return UpdateFaxReadStatusRequestToJSONTyped(json, false);
}

export function UpdateFaxReadStatusRequestToJSONTyped(value?: UpdateFaxReadStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_read': value['is_read'],
    };
}

